import { type RouteRecordRaw } from 'vue-router'

export const ProgramsRouter: RouteRecordRaw[] = [
  {
    path: '/programs',
    component: async () => import('./Programs.vue'),
  },
]
